export const getNamesFromInput = (inputs) => Object.values(inputs.filter((_) => _))?.map((_) => _.name);
//# sourceMappingURL=getNamesFromInput.js.map